// import image from "../../../assets/todo.png";
import img from "../../assets/todo.png";
import img1 from "../../assets/news.png";
import img2 from "../../assets/amazon.png";
import img3 from "../../assets/portfolio.png";
import img4 from "../../assets/resume.png";
import img5 from "../../assets/clone.jpg";
import img6 from "../../assets/netflix.png";
import img7 from "../../assets/slack.png";
export const ProjectData = [
  {
    id: 1,
    title: "Live News App",
    about:
      "In Live news app We can see todays news there have a navbar with different section Home, Business, General , Health, Science, Technology, Sports and Entertainment and when we click any of the section show related news to that section",

    tags: ["reactjs", "HTML", "CSS", "Bootstrap"],
    demo: "",
    github: "https://github.com/iparul/Live-News-App",
    image: img1,
  },
  {
    id: 2,
    title: "Amazon Clone",
    about:
      "In Amazon Clone user can sign in and sign out user can see different product add these product in bucket list and remove from bucket list and user can also see the sum of product and when we remove the product from the bucket automactically subtract the amount from total",
    tags: ["reactjs", "HTML", "CSS"],
    demo: "",
    github: "https://github.com/iparul/Amazon-Clone",
    image: img2,
  },
  {
    id: 3,
    title: "MY Portfolio ",
    about:
      "In this Portfolio website i have mention what i have done so far and what type of projects i have done so far.",
    tags: ["reactjs", "HTML", "CSS"],
    demo: "https://parul-portfolio.netlify.app/",
    github: "https://github.com/iparul/Parul_Portfolio",
    image: img3,
  },
  {
    id: 4,
    title: "ToDo List",
    about:
      "In this TODo List we can read list of tasks, Add new task in the list and if we want to remove any task then click on cross button ",
    tags: ["reactjs", "HTML", "CSS"],
    demo: "",
    github: "https://github.com/iparul/ToDoList",
    image: img,
  },
  {
    id: 5,
    title: "Resume builder",
    about:
      "In this resume builder website simply user add there information like experience, eduction, projects etc and click on download button  ",
    tags: ["reactjs", "HTML", "CSS"],
    demo: "https://resumebuilder-9f657.web.app/",
    github: "https://github.com/iparul/resume_builder",
    image: img4,
  },
  {
    id: 6,
    title: "Inshorts Clone",
    about:
      "In Inshort Clone app user can see news related to business, entertainment, health , science and etc. User can also see country wise news. User can search news also there is night mode also in side setting",
    tags: ["react native", "HTML", "CSS"],
    demo: "",
    github: "https://github.com/iparul/inshort-clone",
    image: img5,
  },
  {
    id: 7,
    title: "Netflix Clone",
    about:
      "In Netflix Clone Showing all the movie data by using themoviedb API User can sign in and sign up by entering email and password for that I am using firebase .User can add movie to my list and whenever user I’ll come these movies always there and user can remove these movies also from my list.When user I will hover over to any movie then they’ll see there trailer also",
    tags: ["react js", "HTML", "CSS", "Fiirebase"],
    demo: "https://netflix-clone3123.netlify.app/",
    github: "https://github.com/iparul/netflix-clone",
    image: img6,
  },
  {
    id: 8,
    title: "Slack Clone",
    about:
      " User can sign in by using google authentication for that I’m using firebase . User can create new rooms and user can message to each other in side any room. ",
    tags: ["react js", "HTML", "CSS", "Fiirebase"],
    demo: "https://slack-clone3123.netlify.app/",
    github: "https://github.com/iparul/slack-clone",
    image: img7,
  },
];
